// import { trackClient } from 'shared/clientTelemetry';
import { parseJSON } from '../../shared/parse';
import { TelemetryClientService } from './TelemetryClientService';

const PREFIX = 'eitumlabelcache://';
const DEFAULT_DASHBOARD_KEEP_MINUTES = 5;

export class StorageCacheService {

  public static getKey = (key?: string) => `${PREFIX}${key || ''}`;

  public static getValue<T>(key: string): T | undefined {
    try {
      const value = sessionStorage.getItem(StorageCacheService.getKey(key));
      if (value) {
        const data = parseJSON(value);
        return (data && new Date() < new Date(data.ts)) ? data.value : undefined;
      }
    } catch (error) {
      TelemetryClientService.error('StorageCacheService.getValue', error);
    }
  }

  public static setValue<T>(key: string, value: T) {
    try {
      const ts = new Date();
      ts.setMinutes(ts.getMinutes() + DEFAULT_DASHBOARD_KEEP_MINUTES);
      sessionStorage.setItem(StorageCacheService.getKey(key), JSON.stringify({ ts, value }));
    } catch (error) {
      TelemetryClientService.error('StorageCacheService.setValue', error);
    }
  }

  // can be optimized further by resetting the cache only for related lists
  // now it simply clears everything related to the current site
  public static resetCache(searchKey?: string) {
    searchKey = StorageCacheService.getKey(searchKey)

    const matchedKeys = new Set<string>();
    for (let i = 0; i < sessionStorage.length; ++i) {
      const key = sessionStorage.key(i) as string;
      if (key.toLowerCase().startsWith(searchKey.toLowerCase())) {
        matchedKeys.add(key);
      }
    }
    matchedKeys.forEach(matchedKey => {
      sessionStorage.removeItem(matchedKey);
    });
  }

}
